import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

const SubjectSkeleton = styled((props) => (
  <Skeleton variant="rect" {...props} />
))`
  ${({ theme }) => `
    width: '100%';
    height: calc(${theme.typography.pxToRem(25)} * ${
    theme.typography.body1.lineHeight
  });
    ${theme.breakpoints.up('md')}: {
      height: calc(${theme.typography.pxToRem(32)} * ${
    theme.typography.body1.lineHeight
  });
    }
  `}
`;

export default SubjectSkeleton;
